import React, { forwardRef, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  FaColumns, FaFilter,
} from 'react-icons/fa';
import './styles.scss';

import EpTable from '../EpTable';
import EpCard from '../EpCard';
import EpButton from '../EpButton';
import EpModalStickColumns from '../EpModalStickColumns';
import EpModalStickFilters from '../EpModalStickFilters';
import EpPagination from '../EpPagination';
import EpPaginationResults from '../EpPaginationResults';
import useTranslation from '../../hooks/useTranslation';
import EpLocalLoading from '../EpLocalLoading';
import { handleToggleModalStick } from '../EpModalStick';

export const toggleColumn = (column, columnsToHide, setColumnsToHide, integrationFuncName,
  lastIntegrationFiltered, setLastIntegrationFiltered, checkboxEvent, isChecked, setIsChecked) => {
  const { accessor } = column;

  if (integrationFuncName !== lastIntegrationFiltered) {
    const tableInitialColumnsToHideObj = column.filter(
      columnObj => columnObj.hideColumnInitially === true,
    );

    const tableInitialColumnsToHide = tableInitialColumnsToHideObj.map(
      columnObj => columnObj.accessor,
    );

    setColumnsToHide([...tableInitialColumnsToHide]);
  } else if (columnsToHide.includes(accessor)) {
    setColumnsToHide(columnsToHide.filter(item => item !== accessor));
  } else {
    setColumnsToHide([...columnsToHide, accessor]);
  }

  setLastIntegrationFiltered(integrationFuncName);

  if (checkboxEvent && checkboxEvent.target) {
    setIsChecked(checkboxEvent.target.checked);
  }

  return { isChecked, columnsToHide };
};

const CheckboxListItem = forwardRef(
  ({
    columnProps, inputName, inputId,
    column, columnsToHide, setColumnsToHide, integrationFuncName,
    lastIntegrationFiltered, setLastIntegrationFiltered,
  }, ref) => {
    const customRef = ref || useRef();
    const initialChecked = !columnProps.hideColumnInitially;
    const [isChecked, setIsChecked] = useState();

    if (customRef && customRef.current && isChecked === undefined) {
      customRef.current.checked = initialChecked;
    }

    return (
      <input
        type="checkbox"
        ref={customRef}
        name={inputName}
        id={inputId}
        onChange={(checkboxEvent) => {
          toggleColumn(
            column,
            columnsToHide,
            setColumnsToHide,
            integrationFuncName,
            lastIntegrationFiltered,
            setLastIntegrationFiltered,
            checkboxEvent,
            isChecked,
            setIsChecked,
          );
        }}
      />
    );
  },
);

const EpSingleTableCard = ({
  tableData, columns, empty, getDataTable, filterSubmitFunc, filterCancelFunc,
  filterBodyContent, filterClearFunc, filterData, integrationFuncData,
  cardTitleIntegration, currentPageNumber, setCurrentPageNumber,
  searchingData, columnsToHide, setColumnsToHide, integrationFuncName,
  lastIntegrationFiltered, setLastIntegrationFiltered,
}) => {
  // Tags do Globalization
  const Columns = useTranslation('Columns');
  const Filters = useTranslation('Filters');

  // const [toolTipInstance, setToolTipInstance] = useState();

  const bodyContentSm = (
    <>
      {columns !== null
        ? (
          <>
            {columns.map((column) => {
              const customRef = column.ref;

              return (
                <div key={column.accessor + integrationFuncName}>
                  <label htmlFor={column.accessor}>
                    <CheckboxListItem
                      customRef={customRef}
                      inputName={column.accessor}
                      inputId={column.accessor}
                      columnProps={column}
                      column={column}
                      columnsToHide={columnsToHide}
                      setColumnsToHide={setColumnsToHide}
                      integrationFuncName={integrationFuncName}
                      lastIntegrationFiltered={lastIntegrationFiltered}
                      setLastIntegrationFiltered={setLastIntegrationFiltered}
                    />
                    {' '}{column.Header}
                  </label>
                </div>
              );
            })}
          </>
        )
        : <> </>}
    </>
  );

  const cardHeader = (
    <div className="card__header-action">
      {/* Botão de Colunas */}
      <div className="dropdown dropdown-columns">
        <EpButton
          buttonIcon={<FaColumns className="btn__icon" />}
          labelText={Columns}
          buttonType="secondary-outline"
          customClass="dropdown-toggle"
          actionType="button"
          buttonId="button__dropdown-columns"
          ariaExpanded="false"
          autoClose="false"
          linkFunc={() => handleToggleModalStick('button__dropdown-columns')}
          disabled={!(tableData !== undefined && tableData !== null && tableData !== '') || tableData.itens.length === 0}
          size="sm"
        />

        <div className="dropdown-menu dropdown__menu" aria-labelledby="button__dropdown-columns">
          <EpModalStickColumns
            modalStickId="modal-stick-columns"
            buttonToggleId="button__dropdown-columns"
            bodyContent={bodyContentSm}
            footerContent={false}
          />
        </div>
      </div>

      {/* Botão de Filtros */}
      <div className="dropdown dropdown-filters">
        <EpButton
          buttonIcon={<FaFilter className="btn__icon" />}
          labelText={Filters}
          buttonType="primary-outline"
          customClass="dropdown-toggle"
          actionType="button"
          buttonId="button__dropdown-filters"
          linkFunc={() => handleToggleModalStick('button__dropdown-filters')}
          ariaExpanded="false"
          autoClose="false"
          size="sm"
        />
        <div className="dropdown-menu dropdown__menu" aria-labelledby="button__dropdown-filters">
          <EpModalStickFilters
            cancelFunc={filterCancelFunc}
            clearFunc={filterClearFunc}
            submitFunc={filterSubmitFunc}
            modalStickId="modal-stick-filters"
            buttonToggleId="button__dropdown-filters"
            bodyContent={filterBodyContent}
            searchingData={searchingData}
          />
        </div>
      </div>

    </div>
  );

  const cardFooter = (
    !(tableData !== undefined && tableData !== null && tableData !== '') || tableData.itens.length === 0
      ? (
        <div className="card__footer-results">
          <EpPaginationResults
            tableData={tableData !== null && tableData.itens.length > 0
        && tableData !== undefined ? tableData : empty}
            getDataFunc={getDataTable}
            disabled
          />
        </div>

      )
      : (
        <div className="card__footer-results">
          <EpPaginationResults
            tableData={tableData !== null && tableData.itens.length > 0
            && tableData !== undefined ? tableData : empty}
            getDataFunc={getDataTable}
            filterData={filterData}
            columns={columns}
            integrationFuncData={integrationFuncData}
            setCurrentPageNumber={setCurrentPageNumber}
          />
          <EpPagination
            tableData={tableData !== null && tableData.itens.length > 0
            && tableData !== undefined ? tableData : empty}
            getDataFunc={getDataTable}
            filterData={filterData}
            columns={columns}
            integrationFuncData={integrationFuncData}
            currentPageNumber={currentPageNumber}
            setCurrentPageNumber={setCurrentPageNumber}
          />
        </div>
      )
  );

  return (
    <EpCard
      cardTitle={cardTitleIntegration}
      cardTitleIntegration={cardTitleIntegration}
      cardHeader={cardHeader}
      // eslint-disable-next-line no-nested-ternary
      cardBody={tableData !== null && tableData.itens.length > 0 && tableData !== undefined
        ? searchingData
          ? (
            <div className="table__body-spinner">
              <EpLocalLoading />
            </div>
          )
          : (
            <EpTable
              tableData={tableData}
              columns={columns}
              hiddenColumns={columnsToHide}
            />
          )
        : empty}
      cardFooter={cardFooter}
    />
  );
};

export default EpSingleTableCard;

CheckboxListItem.defaultProps = {
  inputName: null,
  inputId: null,
};

CheckboxListItem.propTypes = {
  columnProps: PropTypes.objectOf(PropTypes.any).isRequired,
  inputName: PropTypes.string,
  inputId: PropTypes.string,
  column: PropTypes.objectOf(PropTypes.any).isRequired,
  columnsToHide: PropTypes.arrayOf(PropTypes.string).isRequired,
  setColumnsToHide: PropTypes.func.isRequired,
  integrationFuncName: PropTypes.string.isRequired,
  lastIntegrationFiltered: PropTypes.string.isRequired,
  setLastIntegrationFiltered: PropTypes.func.isRequired,
};

EpSingleTableCard.defaultProps = {
  empty: null,
  searchingData: false,
  tableData: null,
  getDataTable: null,
  integrationFuncData: null,
};

EpSingleTableCard.propTypes = {
  tableData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.object),
  ])),
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  empty: PropTypes.element,
  getDataTable: PropTypes.func,
  filterSubmitFunc: PropTypes.func.isRequired,
  filterClearFunc: PropTypes.func.isRequired,
  filterBodyContent: PropTypes.element.isRequired,
  filterData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])).isRequired,
  integrationFuncData: PropTypes.func,
  cardTitleIntegration: PropTypes.string.isRequired,
  currentPageNumber: PropTypes.number.isRequired,
  setCurrentPageNumber: PropTypes.func.isRequired,
  filterCancelFunc: PropTypes.func.isRequired,
  searchingData: PropTypes.bool,
  columnsToHide: PropTypes.arrayOf(PropTypes.string).isRequired,
  setColumnsToHide: PropTypes.func.isRequired,
  integrationFuncName: PropTypes.string.isRequired,
  lastIntegrationFiltered: PropTypes.string.isRequired,
  setLastIntegrationFiltered: PropTypes.func.isRequired,
};
